import { DEFAULT_SUPPLEMENTAL_ITEMS_PATH } from '../constants'
import { getField } from '../fieldResolver'
import { getNested } from '../utils'

function getItemsArrayAtPath (source) {
  const data = source?.data
  if (data == null) return null
  const path = source.displayConfig?.itemsPath ?? DEFAULT_SUPPLEMENTAL_ITEMS_PATH
  const val = getNested(data, path)
  return Array.isArray(val) ? val : null
}

function countVisibleItemsForSource (source, isAdvisor) {
  const arr = getItemsArrayAtPath(source)
  if (!arr) return 0
  if (isAdvisor) return arr.length
  return arr.filter(i => {
    const v = getField(i, source?.displayConfig, 'isInternal')
    return v !== true && v !== 'true'
  }).length
}

/**
 * True when source data has a non-empty array at displayConfig.itemsPath (default "data").
 */
export function sourceHasRenderableTaskItems (source) {
  const arr = getItemsArrayAtPath(source)
  return Array.isArray(arr) && arr.length > 0
}

/**
 * Board row badge: first source with `displayConfig.badge.show === true` wins; counts are summed across sources.
 * When isAdvisor is false, internal rows are excluded so the badge matches the detail panel.
 */
export function getSupplementalRowBadgeSnapshot (supplementalItemData, isLoading, isAdvisor) {
  if (isLoading) return null
  if (!supplementalItemData?.sources?.length) return null
  let total = 0
  let badge = null
  for (const s of supplementalItemData.sources) {
    total += countVisibleItemsForSource(s, isAdvisor)
    if (badge == null && s.displayConfig?.badge?.show === true) {
      badge = s.displayConfig.badge
    }
  }
  if (!badge?.show) return null
  if (total === 0) return null
  return { count: total, badge }
}
